import React from 'react';

import { TextProps } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { A11yWrapper } from 'components/a11y-wrapper';

import { Total, TotalLabel, TotalsRow } from './styled';

export const TaxesAndFeesNextStep: React.FC<React.PropsWithChildren<{ textProps?: TextProps }>> = ({
  textProps,
}) => {
  const { formatMessage } = useIntl();

  return (
    <TotalsRow {...textProps}>
      <A11yWrapper>
        <TotalLabel {...(textProps && { fontSize: 'sm' })}>
          {formatMessage({
            id: 'taxesAndFees',
          })}
        </TotalLabel>
      </A11yWrapper>
      <Total {...(textProps && { fontSize: 'sm' })} testID="totalTax">
        {formatMessage({
          id: 'taxesAndFeesNextStep',
        })}
      </Total>
    </TotalsRow>
  );
};
